import { Form, message, Spin, Select, Col, Button } from "antd";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "react-phone-input-2/lib/high-res.css";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import Endpoints from "../../api/endpoints";
import PageRoutes from "../../utils/routes";
import useSuccessErrorModal from "../../hooks/successErrorModal/useSuccessErrorModal";
import EndpointFunctions from "../../utils/Functions/endpointFunctions";
import PhoneInput from "react-phone-input-2";

const CreateClient = () => {
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  const [form] = Form.useForm();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { showModal, closeModal, ModalComponent } = useSuccessErrorModal();

  const onFinish = async () => {
    setIsLoading(true);
    console.log("---PHONE NUMBER---", phoneNumber);
    console.log("---COUNTRY CODE---", countryCode);

    const requestBody = {
      phoneNumber: phoneNumber,
      countryCode: countryCode,
    };

    const result = await EndpointFunctions.postData({
      endpointURL: Endpoints.createClient,
      axiosPrivate: axiosPrivate,
      requestBody: requestBody,
    });

    if (result.success) {
      setIsLoading(false);
      showModal("Success", "Müşteri oluşturuldu.", () => {
        closeModal();
        navigate(PageRoutes.clients);
      });
    } else {
      setIsLoading(false);
      showModal(result.errorTitle, result.errorMessage, () => {
        closeModal();
      });
    }
  };

  const handlePhoneChange = (value, country, e, formattedValue) => {
    const phoneNumberWithoutCountryCode = value.replace(
      `${country.dialCode}`,
      ""
    );
    setCountryCode(country.dialCode);
    setPhoneNumber(phoneNumberWithoutCountryCode);
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}>
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "20px",
        }}>
        <div style={{ width: "300px" }}>
          <Form.Item
            label="Telefon Numarası"
            rules={[
              { required: true, message: "Telefon numarası gereklidir." },
            ]}>
            <PhoneInput
              country={"tr"}
              countryCodeEditable={true}
              onChange={handlePhoneChange}
              inputProps={{
                required: true,
              }}
              containerStyle={{
                width: "100%",
              }}
            />
          </Form.Item>
        </div>

        <Button style={{ width: "300px" }} type="primary" htmlType="submit">
          Oluştur
        </Button>
      </Form>
      <Spin spinning={isLoading} fullscreen />
      <ModalComponent></ModalComponent>
    </div>
  );
};
export default CreateClient;
